import { Injectable } from '@angular/core';

export interface VisitedChurch { id: string; name: string; }

@Injectable({ providedIn: 'root' })
export class ChurchHistoryService {
  private readonly key = 'church.visited';
  private recent: VisitedChurch[] = [];

  constructor() {
    try {
      const saved = JSON.parse(localStorage.getItem(this.key) || '[]');
      if (Array.isArray(saved)) this.recent = saved.filter(c =>
        c && typeof c.id === 'string' && /^[a-z0-9-]+$/.test(c.id) && c.id !== 'main'
        && typeof c.name === 'string').slice(0, 10);
    } catch {}
  }

  get churches(): VisitedChurch[] { return [...this.recent]; }

  remember(id: string, name: string): void {
    id = id?.trim().toLowerCase();
    if (!id || id === 'main' || !/^[a-z0-9-]+$/.test(id)) return;
    this.recent = [{ id, name: name || id }, ...this.recent.filter(c => c.id !== id)].slice(0, 10);
    try { localStorage.setItem(this.key, JSON.stringify(this.recent)); } catch {}
  }
}
